<template>
    <div v-if="data">
        <div v-if="data.isLoading === true " :class=" 'spinner ' + data.options ">
            <span v-if="data.spinner === 'RotateSquare' "> <RotateSquare :loading="data.isLoading" :color="data.color" :size="data.size"></RotateSquare> </span>
            <span v-if="data.spinner === 'RotateSquare2' "> <RotateSquare2 :loading="data.isLoading" :color="data.color" :size="data.size"></RotateSquare2> </span>
            <span v-if="data.spinner === 'RotateSquare5' "> <RotateSquare5 :loading="data.isLoading" :color="data.color" :size="data.size"></RotateSquare5> </span>
            <span v-if="data.spinner === 'CubeShadow' "> <CubeShadow :loading="data.isLoading" :color="data.color" :size="data.size"></CubeShadow> </span>
            <span v-if="data.spinner === 'DoubleBounce' "> <DoubleBounce :loading="data.isLoading" :color="data.color" :size="data.size"></DoubleBounce> </span>
            <span v-if="data.spinner === 'ScaleOut' "> <ScaleOut :loading="data.isLoading" :color="data.color" :size="data.size"></ScaleOut> </span>
            <span v-if="data.spinner === 'Jumper' "> <Jumper :loading="data.isLoading" :color="data.color" :size="data.size"></Jumper> </span>
            <span v-if="data.spinner === 'Google' "> <Google :loading="data.isLoading" :color="data.color" :size="data.size"></Google> </span>
        </div>
    </div>
</template>

<script>
    import {RotateSquare} from 'vue-loading-spinner';
    import {RotateSquare2} from 'vue-loading-spinner';
    import {RotateSquare5} from 'vue-loading-spinner';
    import {CubeShadow} from 'vue-loading-spinner';
    import {DoubleBounce} from 'vue-loading-spinner';
    import {ScaleOut} from 'vue-loading-spinner';
    import {Jumper} from 'vue-loading-spinner';
    import {Google} from 'vue-loading-spinner';
    export default {
        name: "Spinners",
        components: {
            RotateSquare,
            RotateSquare2,
            RotateSquare5,
            CubeShadow,
            DoubleBounce,
            ScaleOut,
            Jumper,
            Google,
        },
        props: {
            data: Object,
        },
    }
</script>

<style scoped>
.spinner {
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 10px;
}
.spinner span {
    margin: 0 auto;
    position: relative;
    z-index: 6;
}
.spinner.fixed {
    position: fixed;
    z-index: 3;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255,255,255,0.2);
}
.spinner.absolute {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255,255,255,0.2);
    z-index: 3;
}
.spinner.center {
    display: flex;
    align-items: center;
}
</style>
